module.exports = __webpack_public_path__ + "img/article_4_2.c92a9c08.png";